import { isEmpty } from 'lodash';
export const declarationsPreview = (state) => state.declarationsPreview;
export const declarations = (state) => state.declarations;
export const hasDeclarations = (state) => !isEmpty(state.declarations);
export const isLoadingDeclarationsPreview = (state) => state.isLoadingDeclarationsPreview;
export const isLoadingDeclarations = (state) => state.isLoadingDeclarations;
export const declarationForm = (state) => state.declarationForm;
export const attachmentReadability = (state) => state.attachmentReadability;
export const customers = (state) => state.customers;
export const hasCustomers = (state) => !isEmpty(state.customers);
export const isUserCustomer = (state) =>
  !isEmpty(state.customers) && state.customers.some((customer) => customer.isCustomerUser);
export const isLoadingCustomers = (state) => state.isLoadingCustomers;
export const isSavingDeclarations = (state) => state.isSavingDeclarations;
